export enum ERROR_STATUS_TEXT {
  unauthorized = 'Request failed with status code 401',
}
